import { UiIcon } from '../../table/models/input/ui-icon';
import { LoadingTypeEnum } from '../enum/loadingType.enum';
import {DisplayText} from '../../../models/events/displayText';

export class UiLoadingModel {
  isLoading: boolean;
  icon?: UiIcon;
  text?: DisplayText;
  cssClassText!: string;
  type: LoadingTypeEnum;

  constructor(type: LoadingTypeEnum = LoadingTypeEnum.DEFAULT) {
    this.isLoading = false;
    this.type = type;
  }
}
